import { Component, Input } from '@angular/core';


/**
   * Logger Factory
   * ES:
   * @namespace title: title
   * @namespace align: is the align of the content
   *  <ute-simple-card class="" align="center" title="titolo">contenuto</ute-simple-card>
*/

@Component({
  selector: 'ute-simple-card',
  templateUrl: 'ute-simple-card.component.html'
})
export class UteSimpleCardComponent  {
  @Input() title: string;
  @Input() align: string;

  constructor() {}
}


// WEBPACK FOOTER //
// ./src/app/components/commons/atoms/ute-simple-card/ute-simple-card.component.ts